export default "__VITE_ASSET__DdzqAAUi__"